export default __webpack_public_path__ + "locales/zh-CN/SMTPSettings.json?hash=1edb18ed5c8960cd10d414bd5b5d7185";